import React from "react"
import AniLink from "gatsby-plugin-transition-link/AniLink"

function AgainGetQuote() {
  return (
    <div className="container mt-5 pt-5 d-flex flex-column justify-content-center align-items-center text-center">
      <div className="fs-1 text-purple">Got an awesome project idea?</div>
      <div className="fs-5">
        Discuss with our expert consultants and plan it NOW!
      </div>
      <AniLink
        paintDrip
        hex="#551864"
        to="/getQoute"
        className="connectWithUs fs-4 mt-3 px-4 py-2 fw-bold text-white"
        style={{ borderRadius: "22px" }}
        onMouseOver={() => {}}
      >
        Connect with us
      </AniLink>
    </div>
  )
}

export default AgainGetQuote
